import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from 'react-i18next'

import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import PeriodPicker from 'pages/parts/PeriodPicker'
import { httpOk, GET, PUT, FILE_D } from 'helpers/api'
import { returnSign, findKeyFromArrayByValue, formatDate } from 'helpers/helpers'
import MaskedInput from "react-text-mask"

import CreateBulk from './CreateBulk'
import Analytics from './Analytics'
import EventsHistory from './EventsHistory'

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({
		dates: [],
		users: [],
	})
	const [poses, setPoses] = useState([])
	const [employeePositions, setEmployeePositions] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [bulkModal, setBulkModal] = useState({ show: false, initial: {} })
	const [modalUpdate, setModalUpdate] = useState(false)
	const [showAnalytics, setShowAnalytics] = useState(false)
	const [eventsEmployee, setEventsEmployee] = useState(null)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const tableScrollRef = useRef(null)
	const dragStateRef = useRef({
		isMouseDown: false,
		startX: 0,
		startScrollLeft: 0,
		hasDragged: false,
	})
	const [filterData, setFilterData] = useState({
		activeTab: 'time',
		pos_id: reduxAccount.pos_id,
		status: 1,
		search: '',
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
	})

	async function searchWithFilter(passedData = {}) {
		var filterUrl = "/users-attendances"
		var urlParams = ""
		const currentFilterData = passedData.filterData || filterData
		checkFilter(currentFilterData)

		if (currentFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + currentFilterData.pos_id
		if (currentFilterData.employee_position_ids && currentFilterData.employee_position_ids.length > 0) {
			const ids = currentFilterData.employee_position_ids.map(item => item.id).join(',');
			urlParams += returnSign(urlParams) + 'employee_position_ids=' + ids;
		}
		if (currentFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + currentFilterData.search
		if (currentFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + currentFilterData.start_date
		if (currentFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + currentFilterData.end_date

		if (passedData['excel']) {
			urlParams += returnSign(urlParams) + 'excel=true'

			const responseExcel = await FILE_D(`/users-attendances` + urlParams)
			if (httpOk(responseExcel)) {
				// Создаем объект Blob из полученного файла
				const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Создаем ссылку для скачивания файла
				const fileUrl = URL.createObjectURL(file);

				// Создаем ссылку для скачивания файла в браузере
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', `attendances.xlsx`);
				document.body.appendChild(link);
				link.click();

				// Удаляем ссылку после скачивания файла
				URL.revokeObjectURL(fileUrl);
			}
			return
		}

		if (`/users-attendances${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)

		setDropdownIsOpen(false)
	}

	async function updateUsersAttendances(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.check_in_time = formatDate(parseCustomDate(selectedItemCopy.check_in_time), "yyyy-MM-dd HH:mm:ss")
		selectedItemCopy.check_out_time = formatDate(parseCustomDate(selectedItemCopy.check_out_time), "yyyy-MM-dd HH:mm:ss")
		console.log('here')
		const response = await PUT('/users-attendances', selectedItemCopy, { loader: true })
		if (httpOk(response)) {
			toggleModalUpdate()
			searchWithFilter()
		}
	}

	function parseCustomDate(dateStr) {
		// Проверяем, что строка соответствует шаблону DD.MM.YYYY HH:MM
		const regex = /^\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}$/;

		// Если не совпадает — возвращаем null (значит дата еще не полная)
		if (!regex.test(dateStr)) {
			return null;
		}

		const [datePart, timePart] = dateStr.split(' ');
		if (!datePart || !timePart) return null;

		const [day, month, year] = datePart.split('.').map(Number);
		const [hours, minutes] = timePart.split(':').map(Number);

		return new Date(year, month - 1, day, hours, minutes);
	}

	function isValidDate(date) {
		return date instanceof Date && !isNaN(date);
	}

	async function handleChange(e) {
		var selectedItemCopy = { ...selectedItem }
		if (e.target.name === "minutes" && Number(e.target.value) > 59) {
			return;
		}

		selectedItemCopy[e.target.name] = e.target.value;
		if (e.target.name === "hours" || e.target.name === "minutes") {
			let newCheckOutDate = parseCustomDate(selectedItemCopy.check_in_time);

			newCheckOutDate.setHours(newCheckOutDate.getHours() + Number(selectedItemCopy["hours"]));
			newCheckOutDate.setMinutes(newCheckOutDate.getMinutes() + Number(selectedItemCopy["minutes"]));

			selectedItemCopy.check_out_time = formatDate(newCheckOutDate, "dd.MM.yyyy HH:mm")
		}

		if (e.target.name === "check_in_time" || e.target.name === "check_out_time") {
			const parsedCheckIn = parseCustomDate(selectedItemCopy.check_in_time);
			const parsedCheckOut = parseCustomDate(selectedItemCopy.check_out_time);

			if (isValidDate(parsedCheckIn) && isValidDate(parsedCheckOut)) {
				selectedItemCopy.check_in_time = parsedCheckIn;
				selectedItemCopy.check_out_time = parsedCheckOut;

				selectedItemCopy = getItemTimeDifference(selectedItemCopy);

				selectedItemCopy.check_in_time = formatDate(selectedItemCopy.check_in_time, "dd.MM.yyyy HH:mm");
				selectedItemCopy.check_out_time = formatDate(selectedItemCopy.check_out_time, "dd.MM.yyyy HH:mm");
			}
		}

		setSelectedItem(selectedItemCopy)
	}

	function handleClickItem(item = {}) {
		const user = data.users.find(user => user.employee_id === item.employee_id);
		if (!user) return false;
		const entries = user.dates[item.date]['shifts'] ?? [];

		if (!entries.length) {
			toggleModalBulk(true, {
				'employee_ids': [item.employee_id],
				'date': item.date,
			})
		}
	}

	function handleClickTime(employee = {}, date = null) {
		if (employee.dates[date] && employee.dates[date]['shifts'].length) {
			toggleModalUpdate(true, employee.dates[date]['shifts'][0])
		}
	}

	function resetFilter() {
		// Период обязателен для бэка: сброс без дат возвращал 400 и пустой экран.
		// Запрос шлём с новым фильтром — state на этой строке ещё старый
		const nextFilterData = {
			activeTab: filterData.activeTab,
			pos_id: reduxAccount.pos_id,
			status: 1,
			search: '',
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		}

		setFilterData(nextFilterData)
		setFilterDataExist(false)
		searchWithFilter({ filterData: nextFilterData })
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.status === null &&
			currentFilterData.role === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function handleSearchChange(search) {
		const nextFilterData = { ...filterData, search, page: null }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleTableMouseDown(e) {
		if (!tableScrollRef.current) return
		dragStateRef.current.isMouseDown = true
		dragStateRef.current.startX = e.pageX
		dragStateRef.current.startScrollLeft = tableScrollRef.current.scrollLeft
		dragStateRef.current.hasDragged = false
	}

	function handleTableMouseMove(e) {
		if (!dragStateRef.current.isMouseDown || !tableScrollRef.current) return
		const deltaX = e.pageX - dragStateRef.current.startX

		// Keep regular click behavior unless user actually drags.
		if (!dragStateRef.current.hasDragged && Math.abs(deltaX) > 5) {
			dragStateRef.current.hasDragged = true
		}

		if (dragStateRef.current.hasDragged) {
			tableScrollRef.current.scrollLeft = dragStateRef.current.startScrollLeft - deltaX
		}
	}

	function handleTableMouseUp() {
		dragStateRef.current.isMouseDown = false
	}

	function handleTableClickCapture(e) {
		if (dragStateRef.current.hasDragged) {
			e.preventDefault()
			e.stopPropagation()
			dragStateRef.current.hasDragged = false
		}
	}

	function getItemTimeDifference(item) {
		const checkIn = new Date(item.check_in_time);
		const checkOut = new Date(item.check_out_time);

		const diffMs = checkOut - checkIn; // разница в миллисекундах
		const diffMins = Math.floor(diffMs / 1000 / 60); // в минутах
		const hours = Math.floor(diffMins / 60);
		item.minutes = String(diffMins % 60).padStart(2, '0');
		item.hours = hours;

		return item;
	}

	function toggleModalUpdate(bool = false, item = {}) {
		if (bool) {
			item = { ...item }
			item = getItemTimeDifference(item)
			item.check_in_time = formatDate(item.check_in_time, "dd.MM.yyyy HH:mm")
			item.check_out_time = formatDate(item.check_out_time, "dd.MM.yyyy HH:mm")
			item.check_in_time_copy = item.check_in_time
			item.check_out_time_copy = item.check_out_time

			if (item?.hours < 0) item.hours = "00"
		}


		setSelectedItem(item)
		setModalUpdate(bool)
	}

	function toggleModalBulk(bool = false, initial = {}) {
		setBulkModal({ show: bool, initial: initial })
	}

	async function getPoses() {
		const response = await GET('/helper/poses-head')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getEmployeePositions() {
		const response = await GET(`/helper/employee-positions`)
		if (httpOk(response)) setEmployeePositions(response.data)
	}

	useEffect(() => {
		getPoses()
		getEmployeePositions()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('attendances')} [{data.users?.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn btn-outline-primary"
						onClick={() => setShowAnalytics(true)}>
						<i className="uil-chart-line me-1"></i>
						{t('attendance_analytics')}
					</button>
					<button className="btn btn-primary"
						onClick={() => toggleModalBulk(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={handleSearchChange}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('positions')}</label>
												<Select
													isMulti
													isClearable
													options={employeePositions}
													value={filterData.employee_position_ids}
													onChange={(options) => setFilterData({ ...filterData, 'employee_position_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div className="d-flex gap-2">
								<button className="btn btn-outline-primary btn-wide-2"
									title="EXCEL"
									onClick={() => searchWithFilter({ 'excel': true })}>
									<i className="uil uil-file-download-alt"></i>
								</button>

								<button className={`btn btn-wide-2 ${filterData.activeTab === 'time' ? 'btn-primary' : 'btn-outline-primary'}`}
									onClick={() => setFilterData({ ...filterData, 'activeTab': 'time' })}>
									{t('time')}
								</button>
								<button className={`btn btn-wide-2 ${filterData.activeTab === 'shift' ? 'btn-primary' : 'btn-outline-primary'}`}
									onClick={() => setFilterData({ ...filterData, 'activeTab': 'shift' })}>
									{t('shifts')}
								</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<b> - </b>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.employee_position_id &&
									<span className="me-2">
										<b>{t('positions')}: </b>
										{findKeyFromArrayByValue(employeePositions, 'id', filterData.employee_position_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					{/* Смену длиннее порога закрыл следующий приход, а не сотрудник: в часах
					    лежит пауза. Без подписи жёлтые ячейки выглядят произвольными */}
					{data?.users?.some(employee => employee.suspicious_shifts > 0) &&
						<div className="alert alert-warning d-flex align-items-center gap-2 mb-3">
							<i className="uil-exclamation-triangle fs-5"></i>
							<span>{t('attendance_suspicious_hint', { hours: data.suspicious_shift_hours })}</span>
						</div>
					}

					<div className="table-responsive table-attendances"
						ref={tableScrollRef}
						onMouseDown={handleTableMouseDown}
						onMouseMove={handleTableMouseMove}
						onMouseUp={handleTableMouseUp}
						onMouseLeave={handleTableMouseUp}
						onClickCapture={handleTableClickCapture}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '150px' }}>{t('FIO')}</th>
									<th style={{ 'minWidth': '150px' }}>{t('position')}</th>
									{/* Клик по дате — отметить смены за этот день сразу нескольким */}
									{data?.dates?.map((item, index) => (
										<th style={{ 'minWidth': '130px' }} className="text-center td-hover" key={index}
											title={t('attendance_mark_day')}
											onClick={() => toggleModalBulk(true, { 'date': item })}>
											{formatDate(item, "dd.MM.yyyy")}
											{/* День недели под датой: ISO-номер 1 (пн) … 7 (вс) */}
											<div className="text-muted small fw-normal">{t('weekday_short_' + formatDate(item, "i"))}</div>
										</th>
									))}
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('total')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('days')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-end">{t('attendance_suspicious_total')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.users?.map((employee, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={employee.name}>
											<i className="uil-history td-hover me-1" title={t('attendance_events_history')}
												onClick={() => setEventsEmployee(employee)}></i>
											{employee.name}
										</td>
										<td className="td-ellipsis" title={employee.position_name}>{employee.position_name}</td>

										{Object.entries(employee?.dates).map(([date, dateKey], index) => (
											<td key={index} className={!dateKey?.shifts?.length ? 'td-hover' : ''}
												style={dateKey?.is_suspicious ? { 'backgroundColor': '#fff3cd' } : {}}
												onClick={() => {
													if (!dateKey?.shifts?.length) {
														handleClickItem({
															'employee_id': employee.employee_id,
															'date': date,
														})
													}
												}}>
												{filterData.activeTab === 'shift' &&
													<>
														{dateKey.shifts.length > 0 ? (
															/* Пометка кассы в title объясняет, откуда смена на десятки часов */
															dateKey.shifts.map((item, index2) => (
																/* Автозакрытая смена — уход не отмечен, 0 часов до ручной правки */
																<div key={index2} className="text-center td-hover"
																	title={item.is_auto_closed ? t('attendance_auto_closed_hint') : (item.note ?? '')}
																	style={item.is_auto_closed ? { 'backgroundColor': '#f8d7da' } : {}}
																	onClick={() => toggleModalUpdate(true, item)}>
																	{formatDate(item.check_in_time, "HH:mm")} - {item.is_auto_closed ? '?' : formatDate(item.check_out_time, "HH:mm")}
																	{item.is_suspicious &&
																		<i className="uil-exclamation-triangle text-warning ms-1"></i>
																	}
																</div>
															))
														) : (
															<div></div>
														)}
													</>
												}
												{filterData.activeTab === 'time' &&
													<div className="text-center td-hover"
														onClick={() => handleClickTime(employee, date)}>
														{dateKey.total_duration_formatted}
													</div>
												}
											</td>
										))}

										<td className="text-end">
											<b>{employee.total_duration_formatted}</b>
										</td>
										<td className="text-end">
											<b>{employee.total_worked_days}</b>
										</td>
										<td className="text-end"
											style={employee.suspicious_shifts > 0 ? { 'backgroundColor': '#fff3cd' } : {}}>
											{employee.suspicious_shifts > 0 &&
												<b className="text-warning">{employee.suspicious_duration_formatted}</b>
											}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL ANALYTICS */}
			<Analytics
				show={showAnalytics}
				filterData={filterData}
				onHide={() => setShowAnalytics(false)}
			/>
			{/* MODAL ANALYTICS */}

			{/* MODAL BULK */}
			<CreateBulk
				show={bulkModal.show}
				initial={bulkModal.initial}
				posId={filterData.pos_id}
				attendanceUsers={data.users || []}
				onHide={() => toggleModalBulk()}
				onSaved={() => {
					toggleModalBulk()
					searchWithFilter()
				}}
			/>
			{/* MODAL BULK */}

			{/* MODAL EVENTS */}
			<EventsHistory
				show={!!eventsEmployee}
				employee={eventsEmployee}
				startDate={filterData.start_date}
				endDate={filterData.end_date}
				onHide={() => setEventsEmployee(null)}
			/>
			{/* MODAL EVENTS */}

			{/* MODAL UPDATE */}
			<Modal show={modalUpdate} animation={false} centered
 onHide={() => toggleModalUpdate()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('edit')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => updateUsersAttendances(e)} autoComplete="off">
						<div className="d-flex gap-2">
							<div className="w-100">
								<div className="form-group">
									<label>{t('check_in_time')}</label>
									<MaskedInput
										name="check_in_time"
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										onChange={handleChange}
										value={selectedItem?.check_in_time ?? ""}
									/>
								</div>

								<div className="form-group">
									<label>{t('check_out_time')}</label>
									<div className="position-relative">
										<MaskedInput
											name="check_out_time"
											mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
											className="form-control"
											guide={true}
											onChange={handleChange}
											value={selectedItem?.check_out_time ?? ""}
										/>
										<button className="input-button-right delivery"
											disabled={selectedItem.check_out_time}
											onClick={() => setSelectedItem({ ...selectedItem, 'check_out_time': selectedItem.check_in_time })}>
											<i className="uil uil-clock-three input-icon"></i>
										</button>
									</div>
								</div>

								<div className="d-flex align-items-center justify-content-between gap-2 mt-2">
									<label>{t('time')}</label>

									<div className="d-flex align-items-center justify-content-end gap-2">
										<input
											name="hours"
											type="text"
											className="form-control text-end"
											style={{ width: '50px', height: '30px' }}
											onChange={handleChange}
											value={selectedItem?.hours ? selectedItem?.hours : 0}
										/>
										:
										<input
											name="minutes"
											type="text"
											className="form-control text-end"
											style={{ width: '50px', height: '30px' }}
											onChange={handleChange}
											value={selectedItem?.minutes ? selectedItem?.minutes : "00"}
										/>
									</div>
								</div>
							</div>

							<div className="w-100">
								<div>
									<label>{t('check_in_time')}</label>
									<MaskedInput
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										value={selectedItem?.check_in_time_copy ?? ""}
										disabled
									/>
								</div>
								<div>
									<label>{t('check_out_time')}</label>
									<MaskedInput
										mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
										className="form-control"
										guide={true}
										value={selectedItem?.check_out_time_copy ?? ""}
										disabled
									/>
								</div>

							</div>
						</div>

						<div>
							<label>{t('note')}</label>
							<textarea
								className="form-control"
								guide={true}
								onChange={(e) => setSelectedItem({ ...selectedItem, note: e.target.value })}
								value={selectedItem?.note ?? ""}
							/>
						</div>

						<div className="d-flex mt-2">
							<div className="form-check">
								<input className="form-check-input" type="checkbox" id="status"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'status': e.target.checked })} />
								<label class="form-check-label" htmlFor="status">
									{t('delete')}
								</label>
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL UPDATE */}
		</>
	)
}

export default Index